export const formExternalCompanyManagementNaming = {
  NEW_EXTERNAL_COMPANY_MANAGEMENT_FORM: 'new-external-company-management-form',
};
